import Compressor from 'compressorjs'

// 上传图片之前对图片进行一些处理，例如旋转、压缩 等等
const beforeUpload = (file: File) => new Promise((resolve, reject) => {
  const { type } = file
  if (type.includes('image')) {
    // eslint-disable-next-line no-new
    new Compressor(file, {
      quality: 0.6,
      success: resolve,
      error: reject
    })
  } else {
    resolve(file)
  }
})

export default beforeUpload
